import {IconCoffee} from '@tabler/icons-react'
import {Badge} from '@mantine/core'

type Props = {
  breakHours: number
  compact?: boolean
}

export const CoffeeBadge = ({breakHours, compact = false}: Props) => {
  return (
    <Badge
      size={compact ? 'md' : 'lg'}
      circle
      pl={compact ? 2 : 3}
      pt={5}
      variant={'light'}
      color={'#d6985d'}
      c={'#d6985d'}
      title={`Break: ${breakHours}h`}
    >
      <IconCoffee size={compact ? 14 : 18} stroke={1} />
    </Badge>
  )
}
